module.exports = __webpack_public_path__ + "static/media/24_(c)_stephan_anders.e82c5d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/0420/impressionen/24_(c)_stephan_anders.jpg
// module id = 2233
// module chunks = 0